export const LOAD_TASKS = "LOAD_TASKS";
export const FILTER_CLEAR = "FILTER_CLEAR";
export const UPDATE_FILTER = "UPDATE_FILTER";
